import { useTranslation } from 'react-i18next'

import BasicLayout from '@/components/common/BasicLayout/BasicLayout'

type SectionsListLayoutProps = {
  children: React.ReactNode
}

const SectionsListLayout = (props: SectionsListLayoutProps) => {
  const { t } = useTranslation('sections')

  return (
    <BasicLayout
      breadcrumbs={[
        {
          title: t('header.sections'),
          to: '/sections'
        }
      ]}
      header={t('header.sections')}
      moduleName={t('header.administration', { ns: 'common' })}
      routes={[
        {
          title: t('header.section-setup'),
          link: {
            to: '/sections/setup'
          }
        },
        {
          title: t('header.list'),
          link: {
            to: '/sections/list'
          }
        }
      ]}
    >
      {props.children}
    </BasicLayout>
  )
}

export default SectionsListLayout
